<template>
  <section>
    <v-app-bar app color="primary" dark>
      <img
        :src="require('../assets/logo-novaxs-sm.png')"
        alt="NovaXS"
        width="30"
      />

      <v-toolbar-title class="pl-5"
        >{{ accessPoint ? accessPoint.name : "" }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>
    <div>
      <v-subheader
        class="grey lighten-3 body-1 font-weight-bolder"
        style="height: 40px !important"
        >Categorias
      </v-subheader>
      <v-divider></v-divider>
    </div>
    <section>
      <v-list
        v-if="!loading.categories"
        flat
        three-line
        class="pt-0"
        style="overflow: auto"
      >
        <template v-for="(item, index) in categories">
          <v-list-item
            :key="`category-${item.id}`"
            @click="
              $router.push({
                name: 'products',
                params: { id: item.id, category: item.name },
              })
            "
          >
            <v-list-item-avatar size="60">
              <v-img :src="item.image"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-html="item.name"></v-list-item-title>
              <v-list-item-subtitle
                class="overflow-subtitle"
                v-html="item.description"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider
            :key="index"
            v-if="index < categories.length - 1"
          ></v-divider>
        </template>
      </v-list>
      <div v-else>
        <v-skeleton-loader type="list-item-avatar-three-line" class="mt-2" />
        <v-divider></v-divider>
        <v-skeleton-loader type="list-item-avatar-three-line" class="mt-2" />
        <v-divider></v-divider>
        <v-skeleton-loader type="list-item-avatar-three-line" class="mt-2" />
        <v-divider></v-divider>
        <v-skeleton-loader type="list-item-avatar-three-line" class="mt-2" />
      </div>
    </section>
  </section>
</template>

<script>
import CategoryService from "../services/categoryService";
import SettingsService from "../services/settingsService";
import VisitService from "@/services/visitService";
import confirmDialog from "@/components/confirm-dialog";

export default {
  data: () => ({
    token: null,
    pdvs: null,
    accessPoint: null,
    accessPointId: null,
    categories: [],
    loading: {
      categories: false,
    },
  }),
  beforeRouteEnter(to, from, next) {
    if (Object.keys(to.query).length !== 0) {
      next(async (vm) => {
        if (vm.accessPointId)return;
        vm.token = to.query.token;
        vm.pdvs = to.query.pdvs;
        vm.accessPointId = to.query["access-point"];
 
        if (vm.token && vm.accessPointId) {
          localStorage.clear();
          localStorage.setItem("accessToken", vm.token);
          localStorage.setItem("accessPointId", vm.accessPointId);
          // localStorage.setItem(
          //   "tokenExpiration",
          //   new Date(new Date().getTime() + 15 * 60000).toLocaleString("pt-BR")
          // );
        }
        if (vm.pdvs) localStorage.setItem("pdvs", vm.pdvs);
        vm.init();
      });
    }
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    async getCategories() {
      
      const res = await new CategoryService().getCategories({});
      this.categories = res.data;
      this.loading.categories = false;
    },
    selectClient: async function (responseHitsRooms) {
      const indentification = await this.$prompt(
        "Indentificação",
        "Por favor, digite os 4 digitos finais do documento para indentificar o cliente.",
        {
          type: "text",
          required: true,
        }
      );
      let room = null;
      if (indentification.toString().length < 4) {
        confirmDialog.open(
          "Digite pelo menos 4 digitos do documento.",
          () => {
            this.selectClient(responseHitsRooms);
          },
          () => {
            this.selectClient(responseHitsRooms);
          }
        );
        return;
      }
      for (let data of responseHitsRooms.data) {
      
        if (
          data.federalRegistrationNumber !== null &&
          data.federalRegistrationNumber !== undefined &&
          data.federalRegistrationNumber
            .toString()
            .endsWith(indentification.toString())
        ) {
          room = data;
        }
      }
      if (room === null) {
        confirmDialog.open("Cliente não encontrado tente novamente.", () => {
          this.selectClient(responseHitsRooms);
        });
        return;
      }
      localStorage.setItem("room", JSON.stringify(room));
    },
    async init() {
      this.loading.categories = true;

      if (this.accessPoint == null) {
        if (JSON.parse(localStorage.getItem("accessPoint")) != null) {
          this.accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
          this.accessPointId = this.accessPoint.id;
        }else{
          if (JSON.parse(localStorage.getItem("accessPointId")) != null) {
            this.accessPointId = JSON.parse(localStorage.getItem("accessPointId"));
            const res = await new CategoryService().getAccessPoint(this.accessPointId)
            localStorage.setItem("accessPoint",JSON.stringify(res.data))
            this.accessPoint = res.data;
          }else{
            this.loading.categories = false;
            return;
          }   
        }
        
        this.$nextTick(async () => {
 
        const res = await new SettingsService().getByKey("useObservationPwa");
        const settings = res.data;
        let showObservation = false;
        if (settings && settings.length) {
          if ("true" === settings[0].value.toString()) showObservation = true;
        }
        localStorage.setItem("showObservation", showObservation);

        const res1 = await new SettingsService().getByKey("onlyDigitalMenu");
        const settings1 = res1.data;
        let onlyDigitalMenu = false;
        if (settings1 && settings1.length) {
          if ("true" === settings1[0].value.toString()) onlyDigitalMenu = true;
        }
        localStorage.setItem("onlyDigitalMenu", onlyDigitalMenu);
        if (this.accessPoint != null && this.accessPoint.type === "UH") {
          const responseHitsRooms = await new VisitService().getHitsRooms(
            0,
            this.accessPoint.name
          );
          if (
            responseHitsRooms === null ||
            responseHitsRooms === undefined ||
            responseHitsRooms.data === null ||
            responseHitsRooms.data === undefined ||
            responseHitsRooms.data.length === 0
          ) {
            confirmDialog.open(
              "Erro ao buscar quarto, Tente novamente caso persista informe a gerência.",
              () => {
                this.init();
              }
            );
          }
          await this.selectClient(responseHitsRooms);
        }
      });
      }
      
        
      await this.getCategories();
    },
  },
};
</script>

<style>
.overflow-subtitle {
  display: flex !important;
  text-justify: inter-word !important;
  text-align: justify !important;
}

.v-list-item__title {
  white-space: normal !important;
}
</style>
